import React from 'react';
import { useAnnouncementStore } from 'Services/announcementService/store';

/**
 * App-wide live regions — visually hidden nodes a screen reader announces from,
 * one polite and one assertive, rendering whatever {@link useAnnouncementStore}
 * holds.
 *
 * @remarks
 * Mount once near the app root (e.g. `Layout`), never inside a feature that can
 * unmount mid-announcement. `sr-only`, never `hidden` — `display: none` and
 * `visibility: hidden` both drop a node out of the accessibility tree.
 */
export const LiveAnnouncer = (): React.ReactElement => {
  const { polite, assertive } = useAnnouncementStore();

  return (
    <>
      <div
        className="sr-only"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        data-testid="live-announcer-polite"
      >
        {polite}
      </div>
      <div
        className="sr-only"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        data-testid="live-announcer-assertive"
      >
        {assertive}
      </div>
    </>
  );
};
